module.exports = __webpack_public_path__ + "media/toolkits/icon-3-confidence-97fd5dbd.svg";